import { Box, Typography } from '@mui/material'
import { t } from 'i18next'

// Type for our personification user data
export interface PersonificationRowType {
  auth0_id?: string
  crm_id: string
  first_name: string
  last_name: string
  email: string
  region_name: string
  company_name: string
}

// Column header components
export const NameTitle = () => (
  <Box sx={{ pl: '15px', whiteSpace: 'wrap', pr: '5px' }}>
    {t('pages.personification.table.name')}
  </Box>
)

export const CompanyTitle = () => (
  <Box sx={{ whiteSpace: 'wrap', pr: '5px' }}>
    {t('pages.personification.table.company')}
  </Box>
)

export const RegionalAcqTitle = () => (
  <Box sx={{ whiteSpace: 'wrap', pr: '5px' }}>
    {t('pages.personification.table.regionalAcq')}
  </Box>
)

export const ImpersonateTitle = () => (
  <Box sx={{ pr: '24px' }}>
    {t('pages.personification.table.impersonate')}
  </Box>
)

// Column body components
export const NameBody = ({ row }: { row: any }) => (
  <Typography variant='bodySmall' sx={{ pl: '15px' }}>
    {`${row.original.first_name} ${row.original.last_name}`}
  </Typography>
)

export const CompanyBody = ({ row }: { row: any }) => (
  <Typography variant='bodySmall'>
    {row.original.company_name || '-'}
  </Typography>
)

export const RegionalAcqBody = ({ row }: { row: any }) => (
  <Typography variant='bodySmall'>
    {row.original.region_name}
  </Typography>
)
